import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type PackagingType = {
    id: number
    title: string
}

type PackagingTypeDto = {
    title: string
}

export const PackagingTypesApi = createApi({
    reducerPath: 'PackagingTypesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api'
    }),
    endpoints: builder => ({
        getAllPackagingTypes: builder.query<PackagingType[], void>({
            query: () => ({ url: '/packaging-type' })
        }),
    })
})

export const { useGetAllPackagingTypesQuery } = PackagingTypesApi
